import axios from 'axios';


export default {
  getGroups () {
    return axios.get(`/groups`)
      .then(response => response.data);
  },

  getGroup (id) {
    return axios.get(`/groups/${id}`)
      .then(response => response.data);
  }
};
